import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import BannerTitle from '../layouts/about/banner/BannerTitle';
import { Header, Footer, TopBar, BottomBar } from '../layouts/general/index';
import { ContentProject, RelateProject, Sidebar } from '../layouts/project';
import { getProjectById } from '../ApiSeervice';
import { Project } from '../layouts/home01';


  
const ProjectDetail = () => {
      
    const { id: urlId } = useParams();

    const [id, setId] = useState(null);
    const [headers, setHeaders] = useState([]);
    const [banners, setBanners] = useState([]);
    const [project, SetProject] = useState([]);



    useEffect(() => {
        // Component ilk açıldığında state’leri yükle
        setId(urlId);

        setHeaders([
            {
                id: 1,
                logoweb: "assets/img/logo-small.png",
                names: "Projeler",
            }
        ]);


  
    
        async function fetchProject() {
            const projectt = await getProjectById(urlId);
            SetProject(projectt);

            setBanners([
            {
                id: 1,
                links: '/project',
                titlelink: 'Projeler ',
                border: '|',
                // name: 'Project Single',
                heading: projectt.title
            }
        ]);
      
        }
        fetchProject();
        
    }, [urlId]);  // urlId değişirse tekrar yükle



    return (
        <div className="header-fixed page no-sidebar header-style-2 topbar-style-1 menu-has-search">
            <div id="page" className="clearfix">
                <div id="site-header-wrap">
                    <TopBar />
                    {headers.map((data, idx) => (
                        <Header data={data} key={idx} />
                    ))}
                </div>

                {banners.map(data => (
                    <BannerTitle key={data.id} data={data} />
                ))}

                <div id="main-content" className="site-main clearfix">
                    <div id="content-wrap">
                        <div id="site-content" className="site-content clearfix">
                            <div id="inner-content" className="inner-content-wrap">
                                <div className="page-content">
                                    <div className="row-project-detail">
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="themesflat-spacer clearfix" data-desktop={60} data-mobile={60} data-smobile={60} />
                                                    <div className="detail-inner-wrap">
                                                        <Sidebar info={project}/>
                                                        <ContentProject info={project}/>
                                                    </div>
                                                    <div className="themesflat-spacer clearfix" data-desktop={58} data-mobile={60} data-smobile={60} />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="themesflat-lines style-1 line-full line-solid clearfix">
                                                        <span className="line" />
                                                    </div>
                                                    <div className="themesflat-spacer clearfix" data-desktop={46} data-mobile={35} data-smobile={35} />
                                                    {/* <div className="themesflat-headings style-2 clearfix">
                                                        <h2 className="heading">RELATED PROJECTS</h2>
                                                        <div className="sep has-width w80 accent-bg margin-top-3 clearfix" />
                                                    </div> */}
                                                    <div className="themesflat-spacer clearfix" data-desktop={35} data-mobile={35} data-smobile={35} />
                                                    {/* <RelateProject /> */}
                                                    <div className="themesflat-spacer clearfix" data-desktop={80} data-mobile={60} data-smobile={60} />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
                {headers.map((data, idx) => (
                    <BottomBar data={data} key={idx} />
                ))}
            </div>
        </div>
    );
};

export default ProjectDetail;
